function createLogger(prefix, { enabled = true } = {}) {
  return {
    log: (...args) => {
      if (enabled) {
        console.log(`[${prefix}] \u{1F4A1} INFO:`, ...args);
      }
    },
    warn: (...args) => {
      if (enabled) {
        console.warn(`[${prefix}] \u26A0 WARN:`, ...args);
      }
    },
    error: (...args) => {
      if (enabled) {
        console.error(`[${prefix}] \u26D4\uFE0F ERROR:`, ...args);
      }
    }
  };
}
const devLogger = createLogger("@flex-packages/logger");

export { devLogger };
//# sourceMappingURL=devLogger.mjs.map
